<ng-container *ngIf="!isLoading, else loadingTemplate">
  <div
    class="panel_icon-close--left"
    (click)="onClose()">
    <fa-icon [icon]="['fal', 'times']"></fa-icon>
  </div>

  <div class="panel_title">Manual override</div>

  <p>
    Manually overriding a citation prevents other edits from being displayed, and prevents this citation from being 
    updated if you update references in your library or change citation style.
  </p>

  <br>

  <form *ngIf="form" [formGroup]="form">
    <div class="form-group">
      <textarea 
        class="form-control"
        formControlName="overrideText"
        rows="4"
        placeholder="Enter override text">
      </textarea>
      <scs-field-error *ngIf="isSubmitted" [control]="form.controls.overrideText"></scs-field-error>
    </div>
  </form>

  <div class="drawer drawer--panel">
    <div 
      class="button-primary button-primary--sm"
      (click)="onSave()">
      Done
    </div>
    <div 
      class="button-primary button-primary--sm"
      (click)="onReset()">
      Reset default
    </div>
    <div 
      class="button-primary button-primary--sm button-primary--white"
      (click)="onCancel()">
      Cancel
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <div class="loader_overlay">
    <scs-loader class="center-horizontal-vertical"></scs-loader>
  </div>
</ng-template>

